/* Custom Hooks */
import {
  validateProblem,
  validateFile,
  validateAsunto,
  clearImages,
} from "../hooks/uthValidation.js";
import useUth from "../hooks/useUth.js";

/* Libraries */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../components/Modal.js";
import Spinner from "../components/Spinner";
import ErrorMessage from "../components/Error.js";

// imagenes
import imagen from "../images/logo5.png";
// import add from "../images/add.png";
// import del from "../images/delete.png";

/* Styles */
import "../css/stylesUTH.css";
import "../user_uth/user_uth.css";

const FormUTH = (props) => {
  const [estadoModal, cambiarEstadoModal] = useState(false), //Contiene el estado para activar el Modal
    [area, setArea] = useState(""), //Almacena el valor seleccionado en el dropdown Que problema tienes
    [state, setState] = useState(""), //Almacena el valor seleccionado en el dropdown Área Afectada
    [isResp, setResp] = useState(false), //Almacena el valor de la respuesta si el correo existe o no
    [isLoading, setLoading] = useState(false), //Contiene el estado para activar el spinner
    [isError, setError] = useState(false); //Contiene el estado para mostrar el mensaje de error
    // const [inputs, setInputs] = useState([{ cc: '' }]);
  /*
		values: obtiene el estado actual de los valores del formulario
		setField: cambia el estado de los valores del formulario, recibe dos argumentos: el campo (propiedades de initialValues) y su valor,
		errors: obtiene los errores del formulario,
		
	*/

  useEffect(() => {    
    if (props.resp == 0){
      setResp(true);
    } else {
      setResp(false);
      document.getElementById("submitButton").setAttribute("disabled", true);
      document.getElementById("submitButton").className =
          "btn btn-secondary fuente mb-2";
    }
  }, [props.resp] )

  //JSON con lista de opciones para el campo con que tienes problemas
  const areas = [
    { id: "Aplicaciones", name: "Aplicaciones" },
    { id: "Otros", name: "Otros" },
  ];

  //JSON con lista de opciones para el campo Área Afectada de acuerdo al json anterior
  const estados = [
    { id: "Academic", name: "Academic", areaId: "Aplicaciones" },
    { id: "UTH App", name: "App UTH", areaId: "Aplicaciones" },
    { id: "E-Campus", name: "E-Campus", areaId: "Aplicaciones" },
    { id: "E-Learning", name: "E-Learning", areaId: "Aplicaciones" },
    { id: "Accesos/Credenciales", name: "Accesos/Credenciales", areaId: "Otros" },
    { id: "Correo", name: "Correo Electrónico", areaId: "Otros" },
    { id: "Hardware", name: "Hardware", areaId: "Otros" },
    { id: "Internet", name: "Internet", areaId: "Otros" },
    { id: "Otro", name: "Otro", areaId: "Otros" },
  ];

  //Filtro entre Área Afectada y Problemas.
  const filteredProblem = estados.filter((state) => state.areaId === area);

  function ValidFile() {
    var valFile = document.getElementById("file"); //Obtiene la lista de imagenes en el drag and drop
    var valArea = document.getElementById("area").value; //Obtiene el valor del problema descrito por el usuario

    if (
      valArea === "Aplicaciones" &&
      document.getElementById("file").value === ""
    ) {
      valFile.setAttribute("required", true);
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "fuente btn btn-secondary mb-2";
    }

    if (
      valArea === "Aplicaciones" &&
      document.getElementById("file").value !== ""
    ) {
      valFile.setAttribute("required", true);
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "fuente btn btn-primary mb-2";
    }

    if (
      valArea === "Otros" &&
      document.getElementById("asunto").className !==
        "fuente form-control is-valid" &&
      document.getElementById("problem").className !==
        "fuente form-control is-valid"
    ) {
      valFile.removeAttribute("required");
      document.getElementById("area").style.backgroundColor = "white";
      document.getElementById("submitButton").disabled = true;
      document.getElementById("submitButton").className =
        "fuente btn btn-secondary mb-2";
    }

    if (
      valArea === "Otros" &&
      document.getElementById("asunto").className ===
        "fuente form-control is-valid" &&
      document.getElementById("problem").className ===
        "fuente form-control is-valid"
    ) {
      valFile.removeAttribute("required");
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "fuente btn btn-primary mb-2";
    }
  }

  //Funcion para obtener el valor de problemas y resetear Área Afectada
  const handleProblemaChange = (event) => {
    ValidFile();
    setArea(event.target.value);
    setState("");
  };

  //Obtener el valor de Área Afectada
  const handleStateChange = (event) => {
    setState(event.target.value);
  };

  // const handleAddInput = () => {
  //   setInputs([...inputs, { cc: '' }]);
  // };

  // const handleRemoveInput = (index) => {
  //   setInputs(inputs.filter((_, i) => i !== index));
  // };

  // const handleInputChange = (index, event) => {
  //   const newInputs = inputs.map((input, i) => {
  //     if (i === index) {
  //       return { ...input, [event.target.name]: event.target.value };
  //     }
  //     return input;
  //   });
  //   setInputs(newInputs);
  // };

  //Función para contar los caracteres del textarea y mostrarlo
  function contarcaracteres() {
    var total = 1000;

    setTimeout(function () {
      var valor = document.getElementById("problem");
      var texto = valor.value.replace(/\s+/g, "");
      var respuesta = document.getElementById("res");
      var cantidad = texto.length;
      document.getElementById("res").innerHTML = `${total - cantidad}/${total}`;
      if (cantidad > total) {
        respuesta.style.color = "red";
      } else {
        respuesta.style.color = "black";
      }
    }, 10);
  }

  //handleSubmitForm: función que se pasa al onSubmit del formulario para validarlo
  function handleSubmitForm(event) {
    event.preventDefault();
    setLoading(!isLoading);

    let files = document.getElementById("file").files;
    let x = [];
    let fil = [];
    for (let i = 0; i < files.length; i++) {
      (function (file) {
        var reader = new FileReader();
        reader.onload = (file) => {
          x[i] = reader.result;
        };
        reader.readAsDataURL(file);
      })((fil[i] = files[i]));
    }

    let imageRoute = [];
    var file = document.getElementById("file");
    for (let x = 0; x < file.files.length; x++) {
      imageRoute[x] = URL.createObjectURL(file.files[x]);
    }

    var formdata = new FormData();
    formdata.append("name", event.target.name.value);
    formdata.append("email", event.target.email.value);
    formdata.append("area", event.target.area.value);
    formdata.append("state", event.target.state.value);
    formdata.append("asunto", event.target.asunto.value);
    formdata.append("problema", event.target.problem.value);
    formdata.append("campus", event.target.campus.value);
    formdata.append("empresa", "UTH");
    for (var i = 0; i < file.files.length; i++) {
      formdata.append("image", file.files[i]);
    }
    
    var requestOptions = {
      method: "POST",
      Headers: { "Access-Control-Allow-Origin": "*" },
      body: formdata,
      redirect: "follow",
    };

    fetch("https://soporteinversa.uth.hn/api/api/", requestOptions)
      .then((response) => {
        if (!response.ok) {
          // console.log(response)
          setLoading(isLoading);
          setError(!isError);
          close_error();
          newTicket();
          clearImages();
        } else {
          setLoading(!isLoading);
          cambiarEstadoModal(!estadoModal);
        }
        return response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => {
        setLoading(!isLoading);
        // console.log("error", error);
      });
  }

  //Funcion para cambiar el estado de los componentes
  function close(e) {
    setLoading(!isLoading);
    cambiarEstadoModal(!estadoModal);
    setArea("");    
    setState("");
  }

    //Funcion para cambiar el estado de los componentes en caso de error
    function close_error(e) {
      // newTicket();
      setArea("");
      setState("");
    }

  const { values, setFieldValue, errors, resetForm, newTicket } = useUth({
    /* Valores iniciales del formulario */
    initialValues: {
      name: props.name,
      email: props.email,
      asunto: props.asunto,
      resp: props.resp,
      problema: "",
      file: [],
    },

    // validationSchema: validateFormSchema,
    // validateAllFields: true,
    validate: (property, value) => {
      /* Si VALIDATE_ALL_FIELDS es false VALIDATE recibe 2 parámetros: la propiedad y su valor, dependiendo de su propiedad se va a cumplir la regla, si es true, recibe un obj que es el estado de los valores */
      /* Crea un obj vacío fuera de la función validate (línea 32), a continuación crea las reglas y añade propiedades al obj que serán los errores para mostrarlos como errorObj.name = 'Campo obligatorio'. Retorna los errores para validarlos */
      /* ADVERTENCIA: Si usted a proporciona validateAllFields en TRUE y añade dos argumentos en validate, no funcionará la validación, cuando validateAllFields es false recibe dos parametros y cuando es true sólo uno */

      /* Validación en cada campo individualmente */
      const errorObj = {};

      switch (property) {
        case "asunto":
          const testAsunto = validateAsunto({
            asunto: property,
            value,
            required: "Asunto es requerido.",
            max: 100,
            min: 5,
            shortValue:
              "El límite de caracteres ha sido excedido (Máximo 100 caracteres).",
            maxValue:
              "No hay información suficiente en el Asunto (Mínimo 5 caracteres).",
            validateAsunto: "Error, Favor ingresar solo caracteres alfabéticos.",
          });
          Object.assign(errorObj, testAsunto);
          break;
        case "problema":
          const testProblem = validateProblem({
            problema: property,
            value,
            required: "Descripción es requerida.",
            max: 1000,
            min: 20,
            shortValue:
              "El límite de caracteres ha sido excedido (Máximo 1000 caracteres).",
            maxValue:
              "No hay información suficiente para crear el Ticket (Mínimo 20 caracteres).",
          
              validArea: "Con que tienes problemas, es requerido.",
          });
          Object.assign(errorObj, testProblem);
          break;
        case "file":
          /* VERIFICA EL HOOK useValidation y su función validateFile */
          const testFile = validateFile({
            value,
            required: "Documentos ó imágenes son requeridas.",
            max: 5,
            validFile:
              "Formato de archivo no soportado (Permitidos .jpg, .png, .jpeg, .pdf, .docx, .xlsx).",
            shortValue:
              "El máximo de archivos adjuntados ha sido excedido (Máximo 5).",
          });
          Object.assign(errorObj, testFile);
          break;
          default:
            break;
      }

      return errorObj;
    },
    onSubmit: ({ values, resetForm }) => {},
  });

  return (
    //Contenedor para Formulario de UTH
    <div className="container">
      {/* Logo de la empresa */}
      <img src={imagen} alt="" className="img-uth position-absolute top-0 start-0" />
      <div className="form-uth col-auto row justify-content-center">
        {/* Formulario para recolección de información sobre el fallo  */}
        <form className="form-control pt-0" onSubmit={handleSubmitForm}>
          <div className="col-auto text-center">
            {/* Botón para cerrar el form y volver al principal */}
            <button
              type="button"
              id="close"
              className="btn-close"
              onClick={resetForm}
            ></button>
          </div>
          <p className="fw-normal fs-4 text-center">
            Verificación de Usuario UTH
          </p>

          <div className="col-sm">
            <p className="fs-6 mb-0"></p>
          </div>
          {/* Mostrar nombre y correo estáticos desde las props del form anterior */}
          <div className="row g-20">
            <div className="col-sm-6 mb-3">
              <input
                type="text"
                value={props.name}
                id="name"
                name="name"
                className="fuente form-control"
                disabled
              />
            </div>
            <div className="col-sm-6 mb-3">
              <input
                type="email"
                value={props.email}
                id="email"
                name="email"
                className="fuente form-control"
                disabled
              />
            </div>
          </div>

          <div className="col-sm">
            <p className="fs-6 mb-0">Describe tu solicitud</p>
          </div>
          {/* Obtener el tipo de percance y el área afectada */}
          <div className="row gx-12">
            <div className="col-sm-6 mb-2">
              <select
                autoFocus
                className="fuente form-select"
                name="area"
                id="area"
                required
                value={area}
                onChange={handleProblemaChange}
              >
                <option disabled hidden value="">
                  Área
                </option>
                {areas.map((area) => (
                  <option key={area.id} value={area.id}>
                    {area.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-6 mb-2">
              <select
                className="fuente form-select"
                name="state"
                id="state"
                required
                value={state}
                onChange={handleStateChange}
                disabled={!area}
              >
                <option disabled hidden value="">
                  Sub-área
                </option>
                {filteredProblem.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row gx-12">
            {/* Muestra la lista desplegable de los campus UTH a nivel nacional */}
            <div className="col-sm-6 mb-2">
              <select
                className="fuente form-select"
                name="campus"
                id="campus"
                required
              >
                <option hidden value="">
                  Selecciona Campus
                </option>
                <option value="La Ceiba">Ceiba</option>
                <option value="Choloma">Choloma</option>
                <option value="Choluteca">Choluteca</option>
                <option value="Cofradia">Cofradía</option>
                <option value="El Progreso">El Progreso</option>
                <option value="Juticalpa">Juticalpa</option>
                <option value="Puerto Cortes">Puerto Cortés</option>
                <option value="Roatan">Roatán</option>
                <option value="San Pedro Sula">San Pedro Sula</option>
                <option value="Santa Barbara">Santa Bárbara</option>
                <option value="Siguatepeque">Siguatepeque</option>
                <option value="Tegucigalpa">Tegucigalpa</option>
                <option value="Villanueva">Villanueva</option>
                <option value="Virtual/Online">Virtual/Online</option>
              </select>
            </div>
          </div>

          <div className="mb-3">
            {/* Permite ingresar la descripción del problema técnico */}
            <input
              type="text"
              value={values.asunto}
              id="asunto"
              name="asunto"
              placeholder="Asunto..."
              className="fuente form-control"
              onChange={(e) => setFieldValue("asunto", e.target.value)}
            />
            {errors.asunto && (
              <span className="error-message">{errors.asunto}</span>
            )}
          </div>

          <div className="mb-3">
            {/* Permite ingresar la descripción del problema técnico */}
            <textarea
              className="fuente form-control"
              rows={3}
              name="problem"
              id="problem"
              required
              placeholder="Describa su solicitud..."
              value={values.problema}
              onChange={(e) => setFieldValue("problema", e.target.value)}
              onPaste={contarcaracteres()}
              onKeyUp={contarcaracteres()}
            />
            <label className="fuente text text-black" id="res">
              0/0
            </label>
            {/* {errors.problema && <span id='message' className="invalid-feedback">{errors.problema}</span>} */}
            {/* {errors.problema && <span className="error-message">{errors.problema}</span>} */}
            {errors.problema && (
              <span className="error-message">{errors.problema}</span>
            )}
            {/* <label className="col-sm-4 text-danger">{errors.problema}</label> */}
          </div>

          {/*<div className="col-sm">
            <p className="fs-6 mb-0">Seguimiento del caso (CC)</p>
          </div>

          <div className="row g-20">
            {inputs.map((input, index) => (
              <div key={index} className="col-sm-6 mb-3 position-relative">
                <input
                  type="text"
                  value={input.cc}
                  id={`cc-${index}`}
                  name="cc"
                  placeholder="example@uth.hn"
                  className="fuente form-control"
                  onChange={(e) => handleInputChange(index, e)}
                />
                <button
                  className="btn btn-sm position-absolute"
                  style={{ top: '0px', right: '5px' }}
                  onClick={() => handleRemoveInput(index)}
                >
                  <img src={del} alt="Eliminar"  // Ajusta el tamaño según sea necesario
                  />
                </button>
              </div>
            ))}

            <div className="fuente col-sm-2">
              <button
                className="btn"
                type="button"
                id="addButton"
                onClick={handleAddInput}
              >
                <img src={add} alt="Agregar" style={{ width: '20px', height: '20px', margin: '0px' }}/>
              </button>
            </div>
          </div>*/}

          <div className="col-sm">
            <p className="fs-6 mb-0 ">Adjunte Archivos</p>
          </div>
          {/*Admite documentos pdf e imagenes para evidencia del problema */}
          <div>
            <input
              type="file"
              label="Adjunte Archivos"
              id="file"
              name="file"
              className="fuente input_divDropFile"
              accept="image/*,.pdf,.xlsx,.docx"
              multiple
              onChange={(e) => setFieldValue("file", e.target.files)}
            />
            {errors.file && (
              <span className="error-message">{errors.file}</span>
            )}
          </div>

          {/* IMAGE PREVIEW CONTAINER */}
          <div className="containerImg" id="containerFile"></div>

          <div className="fuente d-grid gap-2 col-4 mx-auto">
            <button
              className="btn btn-secondary shadow text-center mt-3 mb-1"
              type="submit"
              id="submitButton"
              disabled
            >
              Crear Ticket
            </button>
          </div>

          {/* Spinner de carga cuando se ejecuta el fetch */}
          <Spinner estado={isLoading} />

          {/* Mensaje de error se visualiza cuando el fetch no funciona correctamente */}
          <ErrorMessage estado={isError} />

          {/* Ventana modal es visible cuando finaliza con éxito la ejecución del fetch */}
          <Modal estado={estadoModal} cambiarEstado={cambiarEstadoModal} titulo={'Éxito'}>
            <Contenido>
              <p className="fs-6">
                Tu ticket ha sido creado satisfactoriamente. Un correo de
                confirmación ha sido enviado a <strong>{props.email}</strong>.
              </p>
              <ContenidoB>
                <BotonT
                  onClick={() => {
                    close();
                    newTicket();
                    clearImages();
                  }}
                >
                  Crea otro ticket
                </BotonT>
                &nbsp;&nbsp;
                <Boton onClick={resetForm}>Cerrar</Boton>
              </ContenidoB>
            </Contenido>
          </Modal>

          {/* Ventana modal es visible cuando el email no existe en empleados o catedráticos */}
          <Modal estado={isResp} cambiarEstado={setResp} titulo={'Alerta'}>
            <Contenido>
              <p className="fs-6">
                Su usuario no es válido. Favor revise sus datos detenidamente.
              </p>
              <ContenidoB>
                <Boton onClick={resetForm}>Cerrar</Boton>
              </ContenidoB>
            </Contenido>
          </Modal>
        </form>
      </div>
    </div>
  );
};

export default FormUTH;

const Contenido = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
  }
`;

const ContenidoB = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Boton = styled.button`
  display: block;
  padding: 10px 35px;
  border-radius: 10px;
  color: #fff;
  border: none;
  background: #1766dc;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-weight: 10;
  font-size: 14px;
  transition: 0.3s ease all;
  &:hover {
    background: #639cf2;
  }
`;
const BotonT = styled.button`
  display: block;
  padding: 10px 5px;
  border-radius: 10px;
  color: #fff;
  border: none;
  background: #8d99a6;
  cursor: pointer;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  transition: 0.3s ease all;
  &:hover {
    background: #babec2;
  }
`;
